<template>
  <div class="notification-history">
    <h4>Notification History</h4>
    <div v-if="notifications.length > 0" class="notifications-list">
      <div v-for="notif in notifications" 
           :key="notif.sent_at" 
           class="notification-item"
           :class="{ 'failed': !notif.success }">
        <div class="notification-header">
          <span class="notification-type">{{ notif.type }}</span>
          <span class="notification-date">{{ formatDate(notif.sent_at) }}</span>
        </div>
        <div class="notification-details">
          <div class="notification-email">
            <i class="fas fa-envelope"></i>
            {{ notif.sent_to }}
          </div>
          <div v-if="!notif.success" class="notification-error">
            <i class="fas fa-exclamation-triangle"></i>
            {{ notif.error_message }}
          </div>
        </div>
      </div>
    </div>
    <div v-else class="no-notifications">
      No notifications found
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'NotificationHistory',
  props: {
    token: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      notifications: []
    }
  },
  methods: {
    async fetchNotifications() {
      try {
        const response = await api.get(`/upload-requests/${this.token}/notifications/`);
        this.notifications = response.notifications;
      } catch (error) {
        console.error('Error fetching notifications:', error);
      }
    },
    formatDate(date) {
      return new Date(date).toLocaleString();
    }
  },
  mounted() {
    this.fetchNotifications();
  }
}
</script>

<style scoped>
.notification-history {
  margin-top: 1rem;
  padding: 1rem;
  background: #f8fafc;
  border-radius: 6px;
}

.notification-item {
  background: white;
  padding: 0.75rem;
  margin-bottom: 0.5rem;
  border-radius: 4px;
  border-left: 3px solid #4a5568;
}

.notification-item.failed {
  border-left-color: #e53e3e;
}

.notification-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;
}

.notification-type {
  font-weight: 500;
}

.notification-date {
  color: #718096;
  font-size: 0.9em;
}

.notification-error {
  color: #e53e3e;
  margin-top: 0.5rem;
}
</style> 